export const subscriptionCategoryFilters = {
  status: {
    fieldPath: 'status',
    fieldReadPath: 'status',
    name: 'status',
    label: 'global.status.label',
    options: [
      {
        text: 'global.fields.status.active.label',
        value: 'active',
      },
      {
        text: 'global.fields.status.inactive.label',
        value: 'inactive',
      },
      {
        text: 'global.fields.status.trash.label',
        value: 'trash',
      },
    ],
    id: 'subscriptions-subscription-category__status',
    rules: [],
    placeholder: 'subscriptions.subscription_category.status.label',
  },
  period_id: {
    fieldPath: 'period_id',
    fieldReadPath: 'period_id',
    name: 'period_id',
    label: 'selects.subscription_category.period_id.label',
    options: [],
    id: 'selects-subscription-category__period-id',
    rules: [],
    placeholder: 'activities.period_group.period.label',
    selectLabel: 'name',
    selectEntity: 'period',
    selectValue: 'id',
    selectMultiple: false,
  },
};

export const membershipCategoryFields = {
  id: {
    fieldPath: 'id',
    fieldReadPath: 'id',
    name: 'id',
    label: 'global.subscription_category.id.label',
    inputType: 'input',
    options: [],
    id: 'global-subscription-category__id',
    veeValidation: true,
    rules: [],
    warningRules: [],
  },
  center_id: {
    fieldPath: 'center_id',
    fieldReadPath: 'center_id',
    name: 'center_id',
    label: 'global.subscription_category.center_id.label',
    inputType: 'input',
    options: [],
    id: 'global-subscription-category__center-id',
    veeValidation: true,
    rules: ['required'],
    warningRules: [],
  },
  code: {
    fieldPath: 'code',
    fieldReadPath: 'code',
    name: 'code',
    label: 'global.subscription_category.code.label',
    inputType: 'input',
    options: [],
    id: 'global-subscription-category__code',
    veeValidation: true,
    rules: ['nullable', 'string', 'without_spaces'],
    warningRules: [],
    tags: [],
  },
  status: {
    fieldPath: 'status',
    fieldReadPath: 'status',
    name: 'status',
    label: 'global.subscription_category.status.label',
    inputType: 'select',
    options: [
      {
        text: 'global.fields.status.active.label',
        value: 'active',
      },
      {
        text: 'global.fields.status.inactive.label',
        value: 'inactive',
      },
    ],
    id: 'global-subscription-category__status',
    veeValidation: true,
    rules: ['required', 'in:active,inactive'],
    warningRules: [],
    defaultValue: 'active',
    valueToColor: [
      {
        value: 'active',
        color: 'border-0 text-white bg-success',
      },
      {
        value: 'inactive',
        color: 'border-0 text-white bg-danger',
      },
    ],
  },
  name: {
    fieldPath: 'name',
    fieldReadPath: 'name',
    name: 'name',
    label: 'global.membership_category.name.label',
    inputType: 'input',
    options: [],
    id: 'global-subscription-category__name',
    veeValidation: true,
    rules: ['required'],
    warningRules: [],
  },
  type: {
    fieldPath: 'type',
    fieldReadPath: 'type',
    name: 'type',
    label: 'global.subscription_category.type.label',
    inputType: 'select',
    options: [
      {
        text: 'global.subscription_category.membership',
        value: 'membership',
      },
      {
        text: 'global.subscription_category.subscription',
        value: 'subscription',
      },
      {
        text: 'global.subscription_category.time_based',
        value: 'time_based',
      },
    ],
    id: 'global-subscription-category__type',
    veeValidation: true,
    rules: ['required'],
    warningRules: [],
  },
  disciplines: {
    fieldPath: 'disciplines',
    fieldReadPath: 'disciplines',
    name: 'disciplines',
    label: 'global.subscription_category.disciplines.label',
    inputType: 'entity-select',
    options: [],
    id: 'global-subscription-category__disciplines',
    veeValidation: true,
    rules: ['nullable'],
    warningRules: [],
    tags: [],
    selectLabel: 'name',
    selectEntity: 'discipline',
  },
  period_id: {
    fieldPath: 'period_id',
    fieldReadPath: 'period_id',
    name: 'period_id',
    label: 'activities.activity.period.label',
    options: [],
    id: 'selects-subscription-category__period-id',
    rules: [],
  },
  period: {
    fieldPath: 'period',
    fieldReadPath: 'period',
    name: 'period',
    label: 'activities.activity.period.label',
    options: [],
    id: 'selects-subscription-category__period-id',
    rules: [],
    selectLabel: 'name',
    selectEntity: 'period',
    // selectValue: 'id',
    selectMultiple: false,
  },
  start_date_type: {
    fieldPath: 'start_date_type',
    fieldReadPath: 'start_date_type',
    name: 'start_date_type',
    label: 'global.subscription_category.start_date_type.label',
    inputType: 'select',
    options: [
      {
        text: 'global.subscription_category.start_date_type.subscription_date',
        value: 'subscription_date',
      },
      {
        text: 'global.subscription_category.start_date_type.fixed_date',
        value: 'fixed_date',
      },
    ],
    id: 'global-subscription-category__start-date-type',
    veeValidation: true,
    rules: ['required'],
    warningRules: [],
  },
  end_date_type: {
    fieldPath: 'end_date_type',
    fieldReadPath: 'end_date_type',
    name: 'end_date_type',
    label: 'global.subscription_category.end_date_type.label',
    inputType: 'select',
    options: [
      {
        text: 'global.subscription_category.end_date_type.fixed_duration',
        value: 'fixed_duration',
      },
      {
        text: 'global.subscription_category.end_date_type.fixed_date',
        value: 'fixed_date',
      },
    ],
    id: 'global-subscription-category__end-date-type',
    veeValidation: true,
    rules: ['required'],
    warningRules: [],
  },
  fixed_start_date: {
    fieldPath: 'fixed_start_date',
    fieldReadPath: 'fixed_start_date',
    name: 'fixed_start_date',
    label: 'global.subscription_category.fixed_start_date.label',
    inputType: 'datepicker',
    options: [],
    id: 'global-subscription-category__fixed-start-date',
    veeValidation: true,
    rules: ['nullable', 'required_if:start_date_type,fixed_date', 'date', 'date_format:Y-m-d'],
    warningRules: [],
  },
  fixed_end_date: {
    fieldPath: 'fixed_end_date',
    fieldReadPath: 'fixed_end_date',
    name: 'fixed_end_date',
    label: 'global.subscription_category.fixed_end_date.label',
    inputType: 'datepicker',
    options: [],
    id: 'global-subscription-category__fixed-end-date',
    veeValidation: true,
    rules: ['nullable', 'required_if:end_date_type,fixed_date', 'date', 'date_format:Y-m-d'],
    warningRules: [],
  },
  price: {
    fieldPath: 'price',
    fieldReadPath: 'price',
    name: 'price',
    label: 'global.subscription_category.price.label',
    inputType: 'input-group',
    options: [],
    id: 'accounting-articles__base-price',
    veeValidation: true,
    rules: ['required', 'numeric'],
    warningRules: [],
    fieldAttributes: {
      autocomplete: 'off',
      type: 'number',
      step: '.001',
    },
    appendIcon: 'euro-sign',
  },
  // duration_type: {
  //   fieldPath: 'duration_type',
  //   fieldReadPath: 'duration_type',
  //   name: 'duration_type',
  //   label: 'global.subscription_category.duration_type.label',
  //   inputType: 'select',
  //   options: [
  //     {
  //       text: 'global.subscription_category.duration_type.days',
  //       value: 'days',
  //     },
  //     {
  //       text: 'global.subscription_category.duration_type.weeks',
  //       value: 'weeks',
  //     },
  //     {
  //       text: 'global.subscription_category.duration_type.months',
  //       value: 'months',
  //     },
  //     {
  //       text: 'global.subscription_category.duration_type.years',
  //       value: 'years',
  //     },
  //   ],
  //   id: 'global-subscription-category__duration-type',
  //   veeValidation: true,
  //   rules: ['required_if:end_date_type,fixed_duration'],
  //   warningRules: [],
  //   tags: [],
  //   fieldAttributes: {
  //     autocomplete: 'off',
  //   },
  //   fieldClass: 'global-subscription-category__duration-type--input',
  //   showError: true,
  //   errorClass: 'global-subscription-category__duration-type--input-error',
  //   errorAttributes: [],
  //   showHelp: false,
  //   helpClass: 'global-subscription-category__duration-type--input-help',
  //   helpAttributes: [],
  //   help: 'global.subscription_category.duration_type.help',
  //   showFeedback: true,
  //   feedbackClass: 'global-subscription-category__duration-type--input-feedback',
  //   feedbackAttributes: [],
  //   feedback: 'global.subscription_category.duration_type.feedback',
  //   showLabel: true,
  //   labelClass: 'global-subscription-category__duration-type--input-label',
  //   labelAttributes: {
  //     for: 'global-subscription-category__duration-type',
  //     cols: 12,
  //     'sr-only': false,
  //     align: 'left',
  //     size: 'md',
  //   },
  //   wrapperAttributes: {
  //     class: {
  //       'inline-field col-md-6': true,
  //     },
  //   },
  //   mediaCollection: [],
  //   disabledByTags: [],
  //   showDefaultValueSwitch: false,
  //   defaultValueSwitchValue: 'default',
  //   conditionalClass: null,
  //   tab: 'subscription',
  //   iconFolder: '',
  //   toTranslate: true,
  //   order: 150,
  //   conditionalShow: {
  //     fieldPath: 'end_date_type',
  //     operator: '=',
  //     value: 'fixed_duration',
  //     actionIfHide: null,
  //   },
  // },
  // fixed_duration_number: {
  //   fieldPath: 'fixed_duration_number',
  //   fieldReadPath: 'fixed_duration_number',
  //   name: 'fixed_duration_number',
  //   label: 'global.subscription_category.fixed_duration_number.label',
  //   inputType: 'input-group',
  //   options: [],
  //   id: 'global-subscription-category__fixed-duration-number',
  //   veeValidation: true,
  //   rules: ['nullable', 'required_if:end_date_type,fixed_duration', 'numeric'],
  //   warningRules: [],
  //   tags: [],
  //   fieldAttributes: {
  //     autocomplete: 'off',
  //     type: 'number',
  //     step: '1',
  //   },
  //   fieldClass: 'global-subscription-category__fixed-duration-number--input',
  //   showError: true,
  //   errorClass: 'global-subscription-category__fixed-duration-number--input-error',
  //   errorAttributes: [],
  //   showHelp: false,
  //   helpClass: 'global-subscription-category__fixed-duration-number--input-help',
  //   helpAttributes: [],
  //   help: 'global.subscription_category.fixed_duration_number.help',
  //   showFeedback: true,
  //   feedbackClass: 'global-subscription-category__fixed-duration-number--input-feedback',
  //   feedbackAttributes: [],
  //   feedback: 'global.subscription_category.fixed_duration_number.feedback',
  //   showLabel: true,
  //   labelClass: 'global-subscription-category__fixed-duration-number--input-label',
  //   labelAttributes: {
  //     for: 'global-subscription-category__fixed-duration-number',
  //     cols: 12,
  //     'sr-only': false,
  //     align: 'left',
  //     size: 'md',
  //   },
  //   wrapperAttributes: {
  //     class: {
  //       'inline-field col-md-6': true,
  //     },
  //   },
  //   mediaCollection: [],
  //   disabledByTags: [],
  //   showDefaultValueSwitch: false,
  //   defaultValueSwitchValue: 'default',
  //   conditionalClass: null,
  //   tab: 'subscription',
  //   iconFolder: '',
  //   conditionalShow: {
  //     fieldPath: 'end_date_type',
  //     operator: '=',
  //     value: 'fixed_duration',
  //     actionIfHide: null,
  //   },
  //   order: 160,
  // },
  // allowed_limit: {
  //   fieldPath: 'allowed_limit',
  //   fieldReadPath: 'allowed_limit',
  //   name: 'allowed_limit',
  //   label: 'global.subscription_category.allowed_limit.label',
  //   inputType: 'input-group',
  //   options: [],
  //   id: 'global-subscription-category__allowed-limit',
  //   veeValidation: true,
  //   rules: ['nullable', 'numeric'],
  //   warningRules: [],
  //   tags: [],
  //   fieldAttributes: {
  //     autocomplete: 'off',
  //     type: 'number',
  //     step: '1',
  //   },
  //   fieldClass: 'global-subscription-category__allowed-limit--input',
  //   showError: true,
  //   errorClass: 'global-subscription-category__allowed-limit--input-error',
  //   errorAttributes: [],
  //   showHelp: false,
  //   helpClass: 'global-subscription-category__allowed-limit--input-help',
  //   helpAttributes: [],
  //   help: 'global.subscription_category.allowed_limit.help',
  //   showFeedback: true,
  //   feedbackClass: 'global-subscription-category__allowed-limit--input-feedback',
  //   feedbackAttributes: [],
  //   feedback: 'global.subscription_category.allowed_limit.feedback',
  //   showLabel: true,
  //   labelClass: 'global-subscription-category__allowed-limit--input-label',
  //   labelAttributes: {
  //     for: 'global-subscription-category__allowed-limit',
  //     cols: 12,
  //     'sr-only': false,
  //     align: 'left',
  //     size: 'md',
  //   },
  //   wrapperAttributes: {
  //     class: {
  //       'col-sm-12': true,
  //     },
  //   },
  //   mediaCollection: [],
  //   disabledByTags: [],
  //   showDefaultValueSwitch: false,
  //   defaultValueSwitchValue: 'default',
  //   conditionalClass: null,
  //   tab: 'subscription',
  //   iconFolder: '',
  //   defaultValue: null,
  //   order: 85,
  // },
  // article_id: {
  //   fieldPath: 'article_id',
  //   fieldReadPath: 'article_id',
  //   name: 'article_id',
  //   label: 'global.subscription_category.article_id.label',
  //   inputType: 'input',
  //   options: [],
  //   id: 'global-subscription-category__article-id',
  //   veeValidation: true,
  //   rules: ['nullable', 'exists:articles,id'],
  //   warningRules: [],
  //   tags: ['hidden'],
  //   fieldAttributes: {
  //     autocomplete: 'off',
  //   },
  //   fieldClass: 'global-subscription-category__article-id--input',
  //   showError: true,
  //   errorClass: 'global-subscription-category__article-id--input-error',
  //   errorAttributes: [],
  //   showHelp: false,
  //   helpClass: 'global-subscription-category__article-id--input-help',
  //   helpAttributes: [],
  //   help: 'global.subscription_category.article_id.help',
  //   showFeedback: true,
  //   feedbackClass: 'global-subscription-category__article-id--input-feedback',
  //   feedbackAttributes: [],
  //   feedback: 'global.subscription_category.article_id.feedback',
  //   showLabel: true,
  //   labelClass: 'global-subscription-category__article-id--input-label',
  //   labelAttributes: {
  //     for: 'global-subscription-category__article-id',
  //     cols: 12,
  //     'sr-only': false,
  //     align: 'left',
  //     size: 'md',
  //   },
  //   wrapperAttributes: {
  //     class: {
  //       'col-sm-12': true,
  //     },
  //   },
  //   mediaCollection: [],
  //   disabledByTags: [],
  //   showDefaultValueSwitch: false,
  //   defaultValueSwitchValue: 'default',
  //   conditionalClass: null,
  //   tab: 'subscription',
  //   iconFolder: '',
  // },
  // article: {
  //   fieldPath: 'article',
  //   fieldReadPath: 'article',
  //   name: 'article',
  //   label: 'global.subscription_category.article.label',
  //   inputType: 'entity-select',
  //   options: [],
  //   id: 'global-subscription-category__article',
  //   veeValidation: true,
  //   rules: ['nullable'],
  //   warningRules: [],
  //   tags: [],
  //   fieldAttributes: {
  //     autocomplete: 'off',
  //   },
  //   fieldClass: 'global-subscription-category__article--input',
  //   showError: true,
  //   errorClass: 'global-subscription-category__article--input-error',
  //   errorAttributes: [],
  //   showHelp: false,
  //   helpClass: 'global-subscription-category__article--input-help',
  //   helpAttributes: [],
  //   help: 'global.subscription_category.article.help',
  //   showFeedback: true,
  //   feedbackClass: 'global-subscription-category__article--input-feedback',
  //   feedbackAttributes: [],
  //   feedback: 'global.subscription_category.article.feedback',
  //   showLabel: true,
  //   labelClass: 'global-subscription-category__article--input-label',
  //   labelAttributes: {
  //     for: 'global-subscription-category__article',
  //     cols: 12,
  //     'sr-only': false,
  //     align: 'left',
  //     size: 'md',
  //   },
  //   wrapperAttributes: {
  //     class: {
  //       'col-sm-12': true,
  //     },
  //   },
  //   mediaCollection: [],
  //   disabledByTags: [],
  //   showDefaultValueSwitch: false,
  //   defaultValueSwitchValue: 'default',
  //   conditionalClass: null,
  //   tab: 'subscription',
  //   iconFolder: '',
  //   selectLabel: 'name',
  //   selectEntity: 'article',
  //   selectMultiple: false,
  //   withTableSearch: true,
  //   displayConfigName: 'search',
  //   withNew: true,
  //   formConfigName: 'default',
  //   order: 170,
  // },
  // option_group_id: {
  //   fieldPath: 'option_group_id',
  //   fieldReadPath: 'option_group_id',
  //   name: 'option_group_id',
  //   label: 'global.subscription_category.option_group_id.label',
  //   inputType: 'input',
  //   options: [],
  //   id: 'global-subscription-category__option-group-id',
  //   veeValidation: true,
  //   rules: ['nullable', 'exists:option_groups,id'],
  //   warningRules: [],
  //   tags: ['hidden'],
  //   fieldAttributes: {
  //     autocomplete: 'off',
  //   },
  //   fieldClass: 'global-subscription-category__option-group-id--input',
  //   showError: true,
  //   errorClass: 'global-subscription-category__option-group-id--input-error',
  //   errorAttributes: [],
  //   showHelp: false,
  //   helpClass: 'global-subscription-category__option-group-id--input-help',
  //   helpAttributes: [],
  //   help: 'global.subscription_category.option_group_id.help',
  //   showFeedback: true,
  //   feedbackClass: 'global-subscription-category__option-group-id--input-feedback',
  //   feedbackAttributes: [],
  //   feedback: 'global.subscription_category.option_group_id.feedback',
  //   showLabel: true,
  //   labelClass: 'global-subscription-category__option-group-id--input-label',
  //   labelAttributes: {
  //     for: 'global-subscription-category__option-group-id',
  //     cols: 12,
  //     'sr-only': false,
  //     align: 'left',
  //     size: 'md',
  //   },
  //   wrapperAttributes: {
  //     class: {
  //       'col-sm-12': true,
  //     },
  //   },
  //   mediaCollection: [],
  //   disabledByTags: [],
  //   showDefaultValueSwitch: false,
  //   defaultValueSwitchValue: 'default',
  //   conditionalClass: null,
  //   tab: 'subscription',
  //   iconFolder: '',
  // },
  // optionGroup: {
  //   fieldPath: 'optionGroup',
  //   fieldReadPath: 'option_group',
  //   name: 'optionGroup',
  //   label: 'global.option_group.label',
  //   inputType: 'entity-select',
  //   options: [],
  //   id: 'global-subscription-category__option-group',
  //   veeValidation: true,
  //   rules: ['nullable'],
  //   warningRules: [],
  //   tags: [],
  //   fieldAttributes: {
  //     autocomplete: 'off',
  //   },
  //   fieldClass: 'global-subscription-category__option-group--input',
  //   showError: true,
  //   errorClass: 'global-subscription-category__option-group--input-error',
  //   errorAttributes: [],
  //   showHelp: false,
  //   helpClass: 'global-subscription-category__option-group--input-help',
  //   helpAttributes: [],
  //   help: 'global.subscription_category.option_group.help',
  //   showFeedback: true,
  //   feedbackClass: 'global-subscription-category__option-group--input-feedback',
  //   feedbackAttributes: [],
  //   feedback: 'global.subscription_category.option_group.feedback',
  //   showLabel: true,
  //   labelClass: 'global-subscription-category__option-group--input-label',
  //   labelAttributes: {
  //     for: 'global-subscription-category__option-group',
  //     cols: 12,
  //     'sr-only': false,
  //     align: 'left',
  //     size: 'md',
  //   },
  //   wrapperAttributes: {
  //     class: {
  //       'col-sm-12': true,
  //     },
  //   },
  //   mediaCollection: [],
  //   disabledByTags: [],
  //   showDefaultValueSwitch: false,
  //   defaultValueSwitchValue: 'default',
  //   conditionalClass: null,
  //   tab: 'subscription',
  //   iconFolder: '',
  //   selectLabel: 'name',
  //   selectEntity: 'option-group',
  //   selectMultiple: false,
  //   withTableSearch: true,
  //   displayConfigName: 'search',
  //   withNew: true,
  //   formConfigName: 'default',
  //   withInfo: false,
  //   order: 180,
  //   filters: [
  //     {
  //       filterField: 'entity_type',
  //       modelField: null,
  //       value: ['subscription_category'],
  //     },
  //   ],
  // },
  // short_description: {
  //   fieldPath: 'short_description',
  //   fieldReadPath: 'short_description',
  //   name: 'short_description',
  //   label: 'global.subscription_category.short_description.label',
  //   inputType: 'textarea',
  //   options: [],
  //   id: 'global-subscription-category__short-description',
  //   veeValidation: true,
  //   rules: ['nullable'],
  //   warningRules: [],
  //   tags: [],
  //   fieldAttributes: {
  //     autocomplete: 'off',
  //   },
  //   fieldClass: 'global-subscription-category__short-description--input',
  //   showError: true,
  //   errorClass: 'global-subscription-category__short-description--input-error',
  //   errorAttributes: [],
  //   showHelp: false,
  //   helpClass: 'global-subscription-category__short-description--input-help',
  //   helpAttributes: [],
  //   help: 'global.subscription_category.short_description.help',
  //   showFeedback: true,
  //   feedbackClass: 'global-subscription-category__short-description--input-feedback',
  //   feedbackAttributes: [],
  //   feedback: 'global.subscription_category.short_description.feedback',
  //   showLabel: true,
  //   labelClass: 'global-subscription-category__short-description--input-label',
  //   labelAttributes: {
  //     for: 'global-subscription-category__short-description',
  //     cols: 12,
  //     'sr-only': false,
  //     align: 'left',
  //     size: 'md',
  //   },
  //   wrapperAttributes: {
  //     class: {
  //       'col-sm-12': true,
  //     },
  //   },
  //   mediaCollection: [],
  //   disabledByTags: [],
  //   showDefaultValueSwitch: false,
  //   defaultValueSwitchValue: 'default',
  //   conditionalClass: null,
  //   tab: 'publication',
  //   iconFolder: '',
  //   order: 10,
  // },
  // published: {
  //   fieldPath: 'published',
  //   fieldReadPath: 'published',
  //   name: 'published',
  //   label: 'global.subscription_category.published.label',
  //   inputType: 'switch',
  //   options: [
  //     {
  //       text: 'global.no',
  //       value: false,
  //     },
  //     {
  //       text: 'global.yes',
  //       value: true,
  //     },
  //   ],
  //   id: 'global-subscription-category__published',
  //   veeValidation: true,
  //   rules: ['required', 'boolean'],
  //   warningRules: [],
  //   tags: [],
  //   fieldAttributes: {
  //     autocomplete: 'off',
  //   },
  //   fieldClass: 'global-subscription-category__published--input',
  //   showError: true,
  //   errorClass: 'global-subscription-category__published--input-error',
  //   errorAttributes: [],
  //   showHelp: false,
  //   helpClass: 'global-subscription-category__published--input-help',
  //   helpAttributes: [],
  //   help: 'global.subscription_category.published.help',
  //   showFeedback: true,
  //   feedbackClass: 'global-subscription-category__published--input-feedback',
  //   feedbackAttributes: [],
  //   feedback: 'global.subscription_category.published.feedback',
  //   showLabel: true,
  //   labelClass: 'global-subscription-category__published--input-label',
  //   labelAttributes: {
  //     for: 'global-subscription-category__published',
  //     cols: 12,
  //     'sr-only': false,
  //     align: 'left',
  //     size: 'md',
  //   },
  //   wrapperAttributes: {
  //     class: {
  //       'col-sm-12': true,
  //     },
  //   },
  //   mediaCollection: [],
  //   disabledByTags: [],
  //   showDefaultValueSwitch: false,
  //   defaultValueSwitchValue: 'default',
  //   conditionalClass: null,
  //   tab: 'publication',
  //   iconFolder: '',
  //   defaultValue: false,
  //   order: 20,
  // },
  // publish_start_date: {
  //   fieldPath: 'publish_start_date',
  //   fieldReadPath: 'publish_start_date',
  //   name: 'publish_start_date',
  //   label: 'global.subscription_category.publish_start_date.label',
  //   inputType: 'datepicker',
  //   options: [],
  //   id: 'global-subscription-category__publish-start-date',
  //   veeValidation: true,
  //   rules: ['nullable', 'date', 'date_format:Y-m-d'],
  //   warningRules: [],
  //   tags: [],
  //   fieldAttributes: {
  //     autocomplete: 'off',
  //   },
  //   fieldClass: 'global-subscription-category__publish-start-date--input',
  //   showError: true,
  //   errorClass: 'global-subscription-category__publish-start-date--input-error',
  //   errorAttributes: [],
  //   showHelp: false,
  //   helpClass: 'global-subscription-category__publish-start-date--input-help',
  //   helpAttributes: [],
  //   help: 'global.subscription_category.publish_start_date.help',
  //   showFeedback: true,
  //   feedbackClass: 'global-subscription-category__publish-start-date--input-feedback',
  //   feedbackAttributes: [],
  //   feedback: 'global.subscription_category.publish_start_date.feedback',
  //   showLabel: true,
  //   labelClass: 'global-subscription-category__publish-start-date--input-label',
  //   labelAttributes: {
  //     for: 'global-subscription-category__publish-start-date',
  //     cols: 12,
  //     'sr-only': false,
  //     align: 'left',
  //     size: 'md',
  //   },
  //   wrapperAttributes: {
  //     class: {
  //       'inline-field col-md-6 pr-2': true,
  //     },
  //   },
  //   mediaCollection: [],
  //   disabledByTags: [],
  //   showDefaultValueSwitch: false,
  //   defaultValueSwitchValue: 'default',
  //   conditionalClass: null,
  //   tab: 'publication',
  //   iconFolder: '',
  //   conditionalShow: {
  //     fieldPath: 'published',
  //     operator: '=',
  //     value: true,
  //   },
  //   order: 40,
  // },
  // publish_start_date_time: {
  //   fieldPath: 'publish_start_date_time',
  //   fieldReadPath: 'publish_start_date_time',
  //   name: 'publish_start_date_time',
  //   label: 'global.subscription_category.publish_start_date_time.label',
  //   inputType: 'time',
  //   options: [],
  //   id: 'global-subscription-category__publish-start-date-time',
  //   veeValidation: true,
  //   rules: ['nullable'],
  //   warningRules: [],
  //   tags: [],
  //   fieldAttributes: {
  //     autocomplete: 'off',
  //   },
  //   fieldClass: 'global-subscription-category__publish-start-date-time--input',
  //   showError: true,
  //   errorClass: 'global-subscription-category__publish-start-date-time--input-error',
  //   errorAttributes: [],
  //   showHelp: false,
  //   helpClass: 'global-subscription-category__publish-start-date-time--input-help',
  //   helpAttributes: [],
  //   help: 'global.subscription_category.publish_start_date_time.help',
  //   showFeedback: true,
  //   feedbackClass: 'global-subscription-category__publish-start-date-time--input-feedback',
  //   feedbackAttributes: [],
  //   feedback: 'global.subscription_category.publish_start_date_time.feedback',
  //   showLabel: true,
  //   labelClass: 'global-subscription-category__publish-start-date-time--input-label',
  //   labelAttributes: {
  //     for: 'global-subscription-category__publish-start-date-time',
  //     cols: 12,
  //     'sr-only': false,
  //     align: 'left',
  //     size: 'md',
  //   },
  //   wrapperAttributes: {
  //     class: {
  //       'inline-field col-md-6 pl-2': true,
  //     },
  //   },
  //   mediaCollection: [],
  //   disabledByTags: [],
  //   showDefaultValueSwitch: false,
  //   defaultValueSwitchValue: 'default',
  //   conditionalClass: null,
  //   tab: 'publication',
  //   iconFolder: '',
  //   conditionalShow: {
  //     fieldPath: 'published',
  //     operator: '=',
  //     value: true,
  //   },
  //   order: 50,
  // },
  // publish_end_date: {
  //   fieldPath: 'publish_end_date',
  //   fieldReadPath: 'publish_end_date',
  //   name: 'publish_end_date',
  //   label: 'global.subscription_category.publish_end_date.label',
  //   inputType: 'datepicker',
  //   options: [],
  //   id: 'global-subscription-category__publish-end-date',
  //   veeValidation: true,
  //   rules: ['nullable', 'date', 'date_format:Y-m-d'],
  //   warningRules: [],
  //   tags: [],
  //   fieldAttributes: {
  //     autocomplete: 'off',
  //   },
  //   fieldClass: 'global-subscription-category__publish-end-date--input',
  //   showError: true,
  //   errorClass: 'global-subscription-category__publish-end-date--input-error',
  //   errorAttributes: [],
  //   showHelp: false,
  //   helpClass: 'global-subscription-category__publish-end-date--input-help',
  //   helpAttributes: [],
  //   help: 'global.subscription_category.publish_end_date.help',
  //   showFeedback: true,
  //   feedbackClass: 'global-subscription-category__publish-end-date--input-feedback',
  //   feedbackAttributes: [],
  //   feedback: 'global.subscription_category.publish_end_date.feedback',
  //   showLabel: true,
  //   labelClass: 'global-subscription-category__publish-end-date--input-label',
  //   labelAttributes: {
  //     for: 'global-subscription-category__publish-end-date',
  //     cols: 12,
  //     'sr-only': false,
  //     align: 'left',
  //     size: 'md',
  //   },
  //   wrapperAttributes: {
  //     class: {
  //       'inline-field col-md-6 pr-2': true,
  //     },
  //   },
  //   mediaCollection: [],
  //   disabledByTags: [],
  //   showDefaultValueSwitch: false,
  //   defaultValueSwitchValue: 'default',
  //   conditionalClass: null,
  //   tab: 'publication',
  //   iconFolder: '',
  //   conditionalShow: {
  //     fieldPath: 'published',
  //     operator: '=',
  //     value: true,
  //   },
  //   order: 60,
  // },
  // publish_end_date_time: {
  //   fieldPath: 'publish_end_date_time',
  //   fieldReadPath: 'publish_end_date_time',
  //   name: 'publish_end_date_time',
  //   label: 'global.subscription_category.publish_end_date_time.label',
  //   inputType: 'time',
  //   options: [],
  //   id: 'global-subscription-category__publish-end-date-time',
  //   veeValidation: true,
  //   rules: ['nullable'],
  //   warningRules: [],
  //   tags: [],
  //   fieldAttributes: {
  //     autocomplete: 'off',
  //   },
  //   fieldClass: 'global-subscription-category__publish-end-date-time--input',
  //   showError: true,
  //   errorClass: 'global-subscription-category__publish-end-date-time--input-error',
  //   errorAttributes: [],
  //   showHelp: false,
  //   helpClass: 'global-subscription-category__publish-end-date-time--input-help',
  //   helpAttributes: [],
  //   help: 'global.subscription_category.publish_end_date_time.help',
  //   showFeedback: true,
  //   feedbackClass: 'global-subscription-category__publish-end-date-time--input-feedback',
  //   feedbackAttributes: [],
  //   feedback: 'global.subscription_category.publish_end_date_time.feedback',
  //   showLabel: true,
  //   labelClass: 'global-subscription-category__publish-end-date-time--input-label',
  //   labelAttributes: {
  //     for: 'global-subscription-category__publish-end-date-time',
  //     cols: 12,
  //     'sr-only': false,
  //     align: 'left',
  //     size: 'md',
  //   },
  //   wrapperAttributes: {
  //     class: {
  //       'inline-field col-md-6 pl-2': true,
  //     },
  //   },
  //   mediaCollection: [],
  //   disabledByTags: [],
  //   showDefaultValueSwitch: false,
  //   defaultValueSwitchValue: 'default',
  //   conditionalClass: null,
  //   tab: 'publication',
  //   iconFolder: '',
  //   conditionalShow: {
  //     fieldPath: 'published',
  //     operator: '=',
  //     value: true,
  //   },
  //   order: 70,
  // },
  // description: {
  //   fieldPath: 'description',
  //   fieldReadPath: 'description',
  //   name: 'description',
  //   label: 'global.subscription_category.description.label',
  //   inputType: 'text-editor',
  //   options: [],
  //   id: 'global-subscription-category__description',
  //   veeValidation: true,
  //   rules: ['nullable'],
  //   warningRules: [],
  //   tags: [],
  //   fieldAttributes: {
  //     autocomplete: 'off',
  //   },
  //   fieldClass: 'global-subscription-category__description--input',
  //   showError: true,
  //   errorClass: 'global-subscription-category__description--input-error',
  //   errorAttributes: [],
  //   showHelp: false,
  //   helpClass: 'global-subscription-category__description--input-help',
  //   helpAttributes: [],
  //   help: 'global.subscription_category.description.help',
  //   showFeedback: true,
  //   feedbackClass: 'global-subscription-category__description--input-feedback',
  //   feedbackAttributes: [],
  //   feedback: 'global.subscription_category.description.feedback',
  //   showLabel: true,
  //   labelClass: 'global-subscription-category__description--input-label',
  //   labelAttributes: {
  //     for: 'global-subscription-category__description',
  //     cols: 12,
  //     'sr-only': false,
  //     align: 'left',
  //     size: 'md',
  //   },
  //   wrapperAttributes: {
  //     class: {
  //       'inline-field col-12': true,
  //     },
  //   },
  //   mediaCollection: [],
  //   disabledByTags: [],
  //   showDefaultValueSwitch: false,
  //   defaultValueSwitchValue: 'default',
  //   conditionalClass: null,
  //   tab: 'publication',
  //   iconFolder: '',
  //   order: 80,
  // },
  // subscription_categories: {
  //   fieldPath: 'subscription_categories',
  //   fieldReadPath: 'subscription_categories',
  //   name: 'subscription_categories',
  //   label: 'global.subscription_category.image.header_label',
  //   inputType: 'file',
  //   options: [],
  //   id: 'global-subscription-category__subscription-categories',
  //   veeValidation: true,
  //   rules: ['nullable', 'max:1024'],
  //   warningRules: [],
  //   tags: ['footer'],
  //   fieldAttributes: {
  //     autocomplete: 'off',
  //   },
  //   fieldClass: 'global-subscription-category__subscription-categories--input',
  //   showError: true,
  //   errorClass: 'global-subscription-category__subscription-categories--input-error',
  //   errorAttributes: [],
  //   showHelp: false,
  //   helpClass: 'global-subscription-category__subscription-categories--input-help',
  //   helpAttributes: [],
  //   help: 'global.subscription_category.subscription_categories.help',
  //   showFeedback: true,
  //   feedbackClass: 'global-subscription-category__subscription-categories--input-feedback',
  //   feedbackAttributes: [],
  //   feedback: 'global.subscription_category.subscription_categories.feedback',
  //   showLabel: true,
  //   labelClass: 'global-subscription-category__subscription-categories--input-label',
  //   labelAttributes: {
  //     for: 'global-subscription-category__subscription-categories',
  //     cols: 12,
  //     'sr-only': false,
  //     align: 'left',
  //     size: 'md',
  //   },
  //   wrapperAttributes: {
  //     class: {
  //       'mt-4': true,
  //     },
  //   },
  //   mediaCollection: {
  //     name: 'subscription_categories',
  //     singleFile: true,
  //     acceptsMimeTypes: ['image/jpg', 'image/jpeg', 'image/png'],
  //     fallbackUrl: null,
  //     fallbackPath: null,
  //     limitedFiles: false,
  //     limitNumberFiles: 0,
  //     responsiveImages: false,
  //   },
  //   disabledByTags: [],
  //   showDefaultValueSwitch: false,
  //   defaultValueSwitchValue: 'default',
  //   conditionalClass: null,
  //   tab: 'publication',
  //   iconFolder: '',
  //   order: 90,
  // },
};

export const membershipFilters = {
  status: {
    fieldPath: 'status',
    fieldReadPath: 'status',
    name: 'status',
    label: 'global.subscription.status.label',
    inputType: 'multi-select',
    options: [
      {
        text: 'global.subscription.requested',
        value: 'requested',
      },
      {
        text: 'global.subscription.requested_not_blocked',
        value: 'requested_not_blocked',
      },
      {
        text: 'global.subscription.ongoing',
        value: 'ongoing',
      },
      {
        text: 'global.subscription.finished',
        value: 'finished',
      },
      {
        text: 'global.subscription.cancelled',
        value: 'cancelled',
      },
      {
        text: 'global.fields.status.trash.label',
        value: 'trash',
      },
    ],
    id: 'global-subscription__status',
    veeValidation: true,
    rules: [],
  },
  membership_payment_status: {
    fieldPath: 'membership_payment_status',
    fieldReadPath: 'membership_payment_status',
    name: 'membership_payment_status',
    label: 'global.subscription.membership_payment_status.label',
    inputType: 'multi-select',
    options: [
      {
        text: 'subscriptions.membership.payment.to_pay',
        value: 'to_pay',
      },
      {
        text: 'subscriptions.membership.payment.ongoing',
        value: 'ongoing',
      },
      {
        text: 'subscriptions.membership.payment.paid',
        value: 'paid',
      },
    ],
    id: 'global-subscription__membership_payment_status',
    veeValidation: true,
    rules: [],
  },
  orders_status: {
    fieldPath: 'orders_status',
    fieldReadPath: 'orders_status',
    name: 'orders_status',
    label: 'global.subscription.orders_status.label',
    inputType: 'multi-select',
    options: [
      {
        text: 'accounting.orders.status.waiting.label',
        value: 'waiting',
      },
      {
        text: 'accounting.orders.status.to_invoice.label',
        value: 'to_invoice',
      },
      {
        text: 'accounting.orders.status.paid.label',
        value: 'paid',
      },
      {
        text: 'accounting.orders.status.invoiced.label',
        value: 'invoiced',
      },
      {
        text: 'accounting.orders.status.cancelled.label',
        value: 'cancelled',
      },
    ],
    id: 'global-subscription__orders-status',
    veeValidation: true,
    rules: [],
  },
  contact_id: {
    fieldPath: 'contact_id',
    fieldReadPath: 'contact_id',
    name: 'contact_id',
    label: 'global.subscription.contact_id.label',
    inputType: 'entity-select',
    options: [],
    id: 'global-subscription__contact-id',
    veeValidation: true,
    rules: [],
  },
};

export const membershipFields = {
  code: {
    fieldPath: 'code',
    fieldReadPath: 'code',
    name: 'code',
    label: 'subscriptions.membership_code_label',
    inputType: 'input',
    options: [],
    id: 'membership__code',
    veeValidation: true,
    rules: ['nullable', 'string', 'without_spaces'],
    warningRules: [],
    tags: [],
  },
  price: {
    fieldPath: 'price',
    fieldReadPath: 'price',
    name: 'price',
    label: 'subscriptions.membership_price_label',
    inputType: 'input-group',
    options: [],
    veeValidation: true,
    rules: ['required', 'numeric'],
    warningRules: [],
    fieldAttributes: {
      autocomplete: 'off',
      type: 'number',
      step: '0.01',
    },
    appendIcon: 'euro-sign',
  },
  ticket_due_date: {
    fieldPath: 'ticket_due_date',
    fieldReadPath: 'ticket_due_date',
    name: 'ticket_due_date',
    label: 'subscriptions.ticket_due_date_label',
    inputType: 'datepicker',
    options: [],
    veeValidation: true,
    rules: ['date', 'date_format:Y-m-d'],
    warningRules: [],
  },
  comment: {
    fieldPath: 'comment',
    fieldReadPath: 'comment',
    name: 'comment',
    label: 'subscriptions.membership_comment_label',
    id: 'membership-comment-field',
    veeValidation: true,
    rules: [],
    warningRules: [],
  },
  invoices: {
    fieldPath: 'invoices',
    fieldReadPath: 'invoices',
    name: 'invoices',
    label: 'subscriptions.membership_invoices_label',
    inputType: 'entity-select',
    options: [],
    id: 'membership__invoices',
    veeValidation: true,
    rules: ['nullable'],
    warningRules: [],
    tags: [],
    selectLabel: 'code',
    selectEntity: 'invoice',
  },
  contact_id: {
    fieldPath: 'contact_id',
    fieldReadPath: 'contact_id',
    name: 'contact_id',
    label: 'subscriptions.membership_contact_label',
    options: [],
    id: 'selects-membership__contact-id',
    rules: [],
    placeholder: 'subscriptions.membership_contact_label',
    selectLabel: 'code_fullname',
    selectEntity: 'contact',
    selectValue: 'id',
    selectMultiple: false,
    filters: [
      {
        filterField: 'type',
        modelField: null,
        value: ['individual'],
      },
    ],
  },
  subscription_category_id: {
    fieldPath: 'subscription_category_id',
    fieldReadPath: 'subscription_category_id',
    name: 'subscription_category_id',
    label: 'subscriptions.membership_category_id',
    options: [],
    id: 'selects-membership__subscription-category-id',
    rules: [],
    placeholder: 'subscriptions.membership_category_label',
    selectLabel: 'name',
    selectEntity: 'subscription-category',
    selectValue: 'id',
    selectMultiple: false,
  },
  status: {
    fieldPath: 'status',
    fieldReadPath: 'status',
    name: 'status',
    label: 'global.subscription.status.label',
    inputType: 'select',
    options: [
      {
        text: 'global.subscription.requested',
        value: 'requested',
      },
      {
        text: 'global.subscription.ongoing',
        value: 'ongoing',
      },
      {
        text: 'global.subscription.finished',
        value: 'finished',
      },
      {
        text: 'global.subscription.cancelled',
        value: 'cancelled',
      },
    ],
    id: 'membership__status',
    veeValidation: true,
    rules: ['required', 'in:active,inactive'],
    warningRules: [],
    defaultValue: 'ongoing',
    valueToColor: [
      { value: 'requested', color: 'border-0 text-white bg-primary' },
      { value: 'ongoing', color: 'border-0 text-white bg-success' },
      { value: 'finished', color: 'border-0 _text-white bg-light' },
      { value: 'cancelled', color: 'border-0 text-white bg-danger' },
    ],
  },
};

export const membershipDisplayFields = {
  status: {
    displayType: 'badge',
    valueToLabel: [
      { value: 'requested', label: 'global.subscription.requested' },
      {
        value: 'requested_not_blocked',
        label: 'global.subscription.requested_not_blocked',
      },
      { value: 'ongoing', label: 'global.subscription.ongoing' },
      { value: 'finished', label: 'global.subscription.finished' },
      { value: 'cancelled', label: 'global.subscription.cancelled' },
    ],
    valueToVariant: [
      { value: 'ongoing', variant: 'success' },
      { value: 'finished', variant: 'light' },
      { value: 'cancelled', variant: 'danger' },
    ],
  },

  contact: {
    displayType: 'contact-link',
    useDrawer: true,
    formConfigName: 'edit',
    drawerSize: 'lg',
    configFileName: 'contact_for_club',
  },
};

export const paymentFilters = {
  code: {
    fieldPath: 'code',
    fieldReadPath: 'code',
    name: 'code',
    label: 'global.payment.code.label',
    inputType: 'input',
    options: [],
    id: 'global-payment__code',
    veeValidation: true,
    rules: ['nullable', 'string', 'without_spaces'],
    warningRules: [],
    tags: [],
  },
  status: {
    fieldPath: 'status',
    fieldReadPath: 'status',
    name: 'status',
    label: 'global.payment.status.label',
    inputType: 'multi-select',
    options: [
      {
        text: 'global.status.waiting',
        value: 'waiting',
      },
      {
        text: 'global.status.ongoing',
        value: 'ongoing',
      },
      {
        text: 'global.status.paid',
        value: 'paid',
      },
      {
        text: 'global.status.cancelled',
        value: 'cancelled',
      },
      {
        text: 'global.status.timer_expired',
        value: 'timer_expired',
      },
      {
        text: 'global.fields.status.trash.label',
        value: 'trash',
      },
    ],
    id: 'global-payment__status',
    veeValidation: true,
    rules: [],
  },
  contact_id: {
    fieldPath: 'contact_id',
    fieldReadPath: 'contact_id',
    name: 'contact_id',
    label: 'global.payment.contact_id.label',
    inputType: 'entity-select',
    options: [],
    id: 'global-payment__contact-id',
    veeValidation: true,
    rules: [],
  },
};

export const paymentDisplayFields = {
  status: {
    displayType: 'badge',
    valueToLabel: [
      { value: 'waiting', label: 'global.status.waiting' },
      { value: 'ongoing', label: 'global.status.ongoing' },
      { value: 'paid', label: 'global.status.paid' },
      { value: 'cancelled', label: 'global.status.cancelled' },
      { value: 'timer_expired', label: 'global.status.timer_expired' },
    ],
    valueToVariant: [
      { value: 'waiting', variant: 'warning' },
      { value: 'ongoing', variant: 'warning' },
      { value: 'paid', variant: 'success' },
      { value: 'cancelled', variant: 'danger' },
      { value: 'timer_expired', variant: 'danger' },
    ],
  },
  payment_method_type: {
    displayType: 'badge',
    valueToLabel: [
      {
        label: 'global.payment.cash',
        value: 'cash',
      },
      {
        label: 'global.payment.wipay_terminal',
        value: 'wipay_terminal',
      },
      {
        label: 'global.payment.money_transfer',
        value: 'money_transfer',
      },
      {
        label: 'global.payment.cheque',
        value: 'cheque',
      },
      {
        label: 'global.payment.sport_cheque',
        value: 'sport_cheque',
      },
      {
        label: 'global.payment.sodexo_cheque',
        value: 'sodexo_cheque',
      },
      {
        label: 'global.payment.stripe',
        value: 'stripe_card',
      },
      {
        label: 'global.payment.bancontact',
        value: 'stripe_bancontact',
      },
      {
        label: 'global.payment.cashdro',
        value: 'cashdro',
      },
    ],
  },
  contact: {
    displayType: 'contact-link',
    useDrawer: true,
    formConfigName: 'edit',
    drawerSize: 'lg',
    configFileName: 'contact_for_club',
  },
};

export const paymentFields = {
  code: {
    fieldPath: 'code',
    fieldReadPath: 'code',
    name: 'code',
    label: 'global.code.label',
    inputType: 'input',
    options: [],
    id: 'global-payment__code',
    veeValidation: true,
    rules: ['nullable', 'string', 'without_spaces'],
    warningRules: [],
    tags: [],
  },
  status: {
    fieldPath: 'status',
    fieldReadPath: 'status',
    name: 'status',
    label: 'global.status.label',
    options: [
      { value: 'waiting', text: 'global.status.waiting' },
      { value: 'ongoing', text: 'global.status.ongoing' },
      { value: 'paid', text: 'global.status.paid' },
      { value: 'cancelled', text: 'global.status.cancelled' },
      { value: 'timer_expired', text: 'global.status.timer_expired' },
    ],
    valueToColor: [
      { value: 'waiting', color: 'border-0 text-white bg-warning' },
      { value: 'ongoing', color: 'border-0 text-white bg-warning' },
      { value: 'paid', color: 'border-0 text-white bg-success' },
      { value: 'cancelled', color: 'border-0 text-white bg-danger' },
      { value: 'timer_expired', color: 'border-0 text-white bg-danger' },
    ],
    id: 'global-payment__status',
    rules: [],
    placeholder: 'payments.payment.status.label',
  },
  paid_amount: {
    fieldPath: 'paid_amount',
    fieldReadPath: 'paid_amount',
    name: 'paid_amount',
    label: 'global.paid_amount.label',
    options: [],
    id: 'global__paid-amount',
    veeValidation: true,
    rules: ['required', 'numeric', 'payment_less_or_equal_invoice_balance'],
    warningRules: [],
    appendIcon: 'euro-sign',
    fieldAttributes: {
      autocomplete: 'off',
      type: 'number',
      step: '0.01',
    },
  },

  payment_method_type: {
    fieldPath: 'payment_method_type',
    fieldReadPath: 'payment_method_type',
    name: 'payment_method_type',
    label: 'global.payment_method_type.label',
    options: [
      {
        text: 'global.payment.cash',
        value: 'cash',
      },
      {
        text: 'global.payment.wipay_terminal',
        value: 'wipay_terminal',
        module: 'payment_terminals',
      },
      {
        text: 'global.payment.money_transfer',
        value: 'money_transfer',
      },
      {
        text: 'global.payment.cheque',
        value: 'cheque',
      },
      {
        text: 'global.payment.sport_cheque',
        value: 'sport_cheque',
      },
      {
        text: 'global.payment.sodexo_cheque',
        value: 'sodexo_cheque',
      },
      // {
      //   text: 'global.payment.stripe',
      //   value: 'stripe',
      // },
      // {
      //   text: 'global.payment.bancontact',
      //   value: 'bancontact',
      // },
      // {
      //   text: 'global.payment.cashdro',
      //   value: 'cashdro',
      // },
    ],
    id: 'global__payment-method-type',
    veeValidation: true,
    rules: [
      'required',
      'in:cash,wipay_terminal,money_transfer,debit_card,credit_card,cheque,sport_cheque,stripe,paypal,bancontact,sodexo_cheque,cashdro',
    ],
    warningRules: [],
  },
  payment_date: {
    fieldPath: 'payment_date',
    fieldReadPath: 'payment_date',
    name: 'payment_date',
    label: 'global.payment_date.label',
    inputType: 'datepicker',
    options: [],
    id: 'global-payment__payment_date',
    veeValidation: true,
    rules: ['nullable', 'date', 'date_format:Y-m-d'],
    warningRules: [],
  },
  payment_time: {
    fieldPath: 'payment_time',
    fieldReadPath: 'payment_time',
    name: 'payment_time',
    label: 'global.payment_time.label',
    inputType: 'time',
    options: [],
    id: 'global-payment__payment_time',
    veeValidation: true,
    rules: ['nullable'],
    warningRules: [],
  },
  contact_id: {
    fieldPath: 'contact_id',
    fieldReadPath: 'contact_id',
    name: 'contact_id',
    label: 'subscriptions.membership_contact_label',
    options: [],
    id: 'selects-membership__contact-id',
    rules: [],
    placeholder: 'subscriptions.membership_contact_label',
    selectLabel: 'code_fullname',
    selectEntity: 'contact',
    selectValue: 'id',
    selectMultiple: false,
  },
  invoice_id: {
    fieldPath: 'invoice_id',
    fieldReadPath: 'invoice_id',
    name: 'invoice_id',
    label: 'global.invoice.label',
    options: [],
    id: 'selects-payment__invoice-id',
    rules: [],
    placeholder: 'global.payment.invoice.label',
    selectLabel: 'code',
    selectEntity: 'invoice',
    selectValue: 'id',
    selectMultiple: false,
  },
};

export const messageFilters = {
  status: {
    fieldPath: 'status',
    fieldReadPath: 'status',
    name: 'status',
    label: 'messages.status.label',
    inputType: 'multi-select',
    options: [
      {
        text: 'global.fields.status.read.label',
        value: 'read',
      },
      {
        text: 'global.fields.status.unread.label',
        value: 'unread',
      },
    ],
    id: 'global-message__status',
    veeValidation: true,
    rules: [],
  },
  sender_receiver_id: {
    fieldPath: 'fullname',
    fieldReadPath: 'fullname',
    name: 'sender_receiver_id',
    label: 'messages.contacts.label',
    inputType: 'entity-select',
    options: [],
    id: 'global-message__sender-receiver-id',
    veeValidation: true,
    rules: [],
  },
  date: {
    fieldPath: 'created_at',
    fieldReadPath: 'created_at',
    name: 'date',
    label: 'messages.created_at.label',
    inputType: 'datepicker',
    id: 'global-message__date',
    veeValidation: true,
    rules: [],
  },
};

export const messageDisplayFields = {
  status: {
    displayType: 'badge',
    valueToLabel: [
      { value: 'read', label: 'global.fields.status.read.label' },
      { value: 'unread', label: 'global.fields.status.unread.label' },
    ],
    valueToVariant: [
      { value: 'read', variant: 'success' },
      { value: 'unread', variant: 'warning' },
    ],
  },
  receivers: {
    displayType: 'array',
    fieldPath: 'fullname',
    fieldReadPath: 'fullname',
  },
  channels: {
    displayType: 'array',
    valueToLabel: [
      { value: 'internal', label: 'global.fields.channels.internal.label' },
      { value: 'mail', label: 'global.fields.channels.mail.label' },
    ],
  },
};

export const messageFields = {
  sender_id: {
    fieldPath: 'sender_id',
    fieldReadPath: 'sender_id',
    name: 'sender_id',
    label: 'global.sender.label',
    inputType: 'input',
    options: [],
    id: 'global-message_sender_id',
    veeValidation: true,
    rules: ['nullable'],
    warningRules: [],
    tags: [],
  },
  status: {
    fieldPath: 'status',
    fieldReadPath: 'status',
    name: 'status',
    label: 'global.status.label',
    options: [
      { value: 'read', text: 'global.fields.status.read.label' },
      { value: 'unread', text: 'global.fields.status.unread.label' },
    ],
    valueToColor: [
      { value: 'read', color: 'border-0 text-white bg-success' },
      { value: 'unread', color: 'border-0 text-white bg-warning' },
    ],
    id: 'global-message__status',
    rules: [],
    placeholder: 'messages.status.label',
  },
  receivers: {
    fieldPath: 'contact_id',
    fieldReadPath: 'contact_id',
    name: 'receivers',
    label: 'messages.receivers.label',
    options: [],
    id: 'selects-message__receivers',
    rules: [],
    placeholder: 'messages.receiverse.label',
    selectLabel: 'code_fullname',
    selectEntity: 'contact',
    selectValue: 'id',
    selectMultiple: false,
  },
  title: {
    fieldPath: 'title',
    fieldReadPath: 'title',
    name: 'title',
    label: 'messages.title.label',
    options: [],
    id: 'global__title',
    veeValidation: true,
    rules: ['required'],
    warningRules: [],
  },
  message: {
    fieldPath: 'message',
    fieldReadPath: 'message',
    name: 'message',
    label: 'messages.message.label',
    options: [],
    id: 'global__message',
    veeValidation: true,
    rules: ['required'],
    warningRules: [],
  },
};
